import { useParams } from 'react-router-dom';

import MixApplyPreview from 'pages/VisualPlayground/components/MixApplyPreview';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const MixApplyPreviewRoute: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { variant } = useParams<{ variant: string }>();

    return <MixApplyPreview className={className} testId={testId} variant={variant ?? null} />;
};

export default MixApplyPreviewRoute;
